// extracted by mini-css-extract-plugin
export var body = "_k8-0";
export var sectionHeader = "_k8-4";
export var shortcutColumns = "_k8-2";
export var shortcutList = "_k8-1";
export var shortcutSection = "_k8-3";